import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const appStandardInsightsPlugin = createPlugin({
  id: 'app-standard-insights',
  routes: {
    root: rootRouteRef,
  },
});

export const AppStandardInsightsPage = appStandardInsightsPlugin.provide(
  createRoutableExtension({
    name: 'AppStandardInsightsPage',
    component: () => import('./App').then(m => m.App),
    mountPoint: rootRouteRef,
  }),
);
